<template>
  <div class="hb-fixed-btn" style="z-index: 999999">
    <div class="desc" v-if="desc">
      {{ desc }}
      <el-tooltip content="标记为 * 的为必填项">
        <i class="el-icon-question" />
      </el-tooltip>
    </div>
    <div class="btn-wrapper" @click="clickAction">
      <div class="label">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HBFixedButton",
  props: {
    desc: undefined,
  },
  methods: {
    clickAction() {
      this.$emit("click");
    },
  },
};
</script>
<style scoped lang="scss">
.hb-fixed-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 60px;
  right: 60px;
  .btn-wrapper {
    width: 60px;
    height: 60px;
    background-color: #409eff;
    border-radius: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 4px 3px #b6b5b5;
    .label {
      font-size: 24px;
      color: #fff;
      font-weight: 500;
    }
  }
  .desc {
    margin-bottom: 10px;
    background-color: #e2e1e1;
    padding: 5px;
    border-radius: 5px;
    color: #7e7e7e;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/HBCommon/HBFixedButton/HBFixedButton.vue